import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers/index";
import thunkMiddleware from "redux-thunk";
import { sessionService } from "redux-react-session";

const isDev = process.env.NODE_ENV === "development";

const middleware = [thunkMiddleware];
if (isDev) {
	// eslint-disable-next-line global-require
	const { createLogger } = require("redux-logger");
	middleware.push(createLogger({ collapsed: true }));
}

// Redux DevTools exposes the whole store (tokens included), so dev only
const composeEnhancers = (isDev && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const store = createStore(reducers, undefined, composeEnhancers(applyMiddleware(...middleware)));

const options = { refreshOnCheckAuth: false, redirectPath: "/login", driver: "COOKIES" };
sessionService.initSessionService(store, options).catch(() => { });

export default store;
